import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField
} from '@mui/material';
import i18n from '../../i18n';
import { LoadingButton } from '@mui/lab';

export default function ModifiedDialog({ open, onSubmit, onCancel }) {
    const [reason, setReason] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async () => {
        if (reason.trim() === '') return;
        setLoading(true);
        await onSubmit(reason.trim());
        setLoading(false);
        setReason('');
    };

    const handleClose = () => {
        setReason('');
        onCancel();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>{i18n.t('dialogs.modifiedDialogTitle')}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label={i18n.t('text.enterModifiedReason')}
                    type="text"
                    fullWidth
                    required
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit" disabled={loading}>
                    {i18n.t('buttons.cancel')}
                </Button>
                <LoadingButton
                    loading={loading}
                    onClick={handleSubmit}
                    color="primary"
                    variant="contained"
                    disabled={!reason.trim()}
                >
                    {i18n.t('buttons.save')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
